import { h, } from '@stencil/core';
import { productCtasButtonType, productCtasColors, myProductsResponseStatus, EAvailabilityType, EApcButtonType, EQdsButtonImportance, EQdsButtonSize, send, addToCartRelatedProductsEvent, removeFromFavoritesEvent, isAnalyticsEnabled, parseCommonURLToRouterParts, join, getLocaleFromBody, getDataAttributes, getQdsIconLibrary, ConfiguratorHandler, CheckoutEventEmitter } from '@pes-ui/utils';
import cn from 'classnames';
import { addToCart } from '../../../../globals/apc-cta/utils';
import { isBrowser } from '../../../../globals/utils';
import { isProductInMyProducts } from '../../../../globals/my-products/utils';
import PesRoute from '../../../pes-router/pes-route';
import { getCustomProductCTAs, getIsProductsInCustomCart, isAppRoutingEnabled, navigateWithRouter, } from '../../../pes-router/utils';
import { getCtaInfoMapping } from '../../../../globals/utils/helpers';
export class RelatedProductCard {
  constructor() {
    var _a;
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.isApc = Boolean(window.isApc);
    this.setInCart = () => {
      var _a, _b, _c, _d;
      if (!isAppRoutingEnabled()) {
        if (!this.myProducts || this.myProducts.length === 0) {
          this.inCart = false;
          return;
        }
        this.inCart = isProductInMyProducts({ [(_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.skuId]: 1 }, this.myProducts);
      }
      else {
        this.inCart = getIsProductsInCustomCart([(_d = (_c = this.product) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.skuId]);
      }
    };
    this.onProductCardClicked = () => {
      var _a, _b;
      this.productCardClicked.emit((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.skuId);
    };
    this.getAnalyticData = (buttonType) => {
      var _a, _b;
      const { skuId: id, description } = (_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) !== null && _b !== void 0 ? _b : {};
      const { currency: currencyCode = '', price = null, brand = '' } = this.product;
      const product = {
        id,
        price,
        brand,
        name: description,
        category: '',
        quantity: 1,
      };
      if (buttonType === productCtasButtonType.FAVORITES && this.inCart) {
        return {
          currencyCode,
          products: [product],
        };
      }
      return {
        currencyCode,
        relatedSectionId: this.groupId,
        distributor: '',
        products: [Object.assign(Object.assign({}, product), { variant: this.productId })],
      };
    };
    this.sendAnalytics = (buttonType) => {
      switch (buttonType) {
        case productCtasButtonType.CART:
          send(addToCartRelatedProductsEvent, this.getAnalyticData(buttonType));
          break;
        case productCtasButtonType.FAVORITES:
          if (this.inCart) {
            send(removeFromFavoritesEvent, this.getAnalyticData(buttonType));
          }
          else {
            send(addToCartRelatedProductsEvent, this.getAnalyticData(buttonType));
          }
          break;
        default:
          break;
      }
    };
    this.getOnCTAClickHandler = (productId, buttonType, inCart) => (event) => {
      const commonProps = {
        initialEvent: event,
        type: buttonType,
        product: {
          id: productId,
        },
        bannerContext: 'body',
      };
      if (buttonType === productCtasButtonType.CART
        || buttonType === productCtasButtonType.FAVORITES) {
        this.ctaClick.emit(Object.assign(Object.assign({}, commonProps), { inList: inCart, onFinish: (result) => {
            if ((result === null || result === void 0 ? void 0 : result.status) === myProductsResponseStatus.SUCCESS) {
              this.inCart = !this.inCart;
            }
          } }));
        if (isAnalyticsEnabled()) {
          this.sendAnalytics(buttonType);
        }
        return;
      }
      this.ctaClick.emit(Object.assign({}, commonProps));
    };
    this.ctaToComponents = (cta) => {
      return Object.keys(cta.buttons).map((buttonType) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const buttonSettings = cta.buttons[buttonType];
        if (!buttonSettings.isShown) {
          return null;
        }
        const inCart = ((_a = buttonSettings.list) === null || _a === void 0 ? void 0 : _a.includes((_c = (_b = this.product) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.skuId)) || false;
        const commonProps = Object.assign({ class: 'related-product-card__button', size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, variant: 'hero', onClick: this.getOnCTAClickHandler((_e = (_d = this.product) === null || _d === void 0 ? void 0 : _d.product) === null || _e === void 0 ? void 0 : _e.skuId, buttonType, inCart) }, getDataAttributes(buttonSettings.dataset));
        if (buttonType === productCtasButtonType.FAVORITES) {
          const isInFavorites = buttonSettings.list.includes((_g = (_f = this.product) === null || _f === void 0 ? void 0 : _f.product) === null || _g === void 0 ? void 0 : _g.skuId);
          const label = isInFavorites
            ? buttonSettings.labels.removeLabel
              || ((_h = this.secondaryCTALabels) === null || _h === void 0 ? void 0 : _h.removeFromFavoritesLabel)
              || ((_j = this.product) === null || _j === void 0 ? void 0 : _j.removeFromCartLabel)
            : buttonSettings.labels.addLabel
              || ((_k = this.secondaryCTALabels) === null || _k === void 0 ? void 0 : _k.addToFavoritesLabel)
              || ((_l = this.product) === null || _l === void 0 ? void 0 : _l.addToCartLabel);
          const icon = buttonSettings.icons[isInFavorites ? 'removeIcon' : 'addIcon'];
          return (h("qds-button", Object.assign({}, commonProps, { iconName: icon, iconLibrary: getQdsIconLibrary(icon), text: label })));
        }
        if (buttonType === productCtasButtonType.CART) {
          const label = buttonSettings.labels.addLabel
            || ((_m = this.secondaryCTALabels) === null || _m === void 0 ? void 0 : _m.addToCartLabel)
            || ((_o = this.product) === null || _o === void 0 ? void 0 : _o.addToCartLabel);
          return (h("qds-button", Object.assign({}, commonProps, { iconName: buttonSettings.icons.addIcon, iconLibrary: getQdsIconLibrary(buttonSettings.icons.addIcon), text: label })));
        }
        return (h("qds-button", Object.assign({}, commonProps, { iconName: buttonSettings.icon, iconLibrary: getQdsIconLibrary(buttonSettings.icon), text: buttonSettings.label })));
      });
    };
    this.buildCTAButtonByResponse = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
      const commonProps = {
        isShown: true,
        color: productCtasColors.SECONDARY_BLUE,
      };
      if (this.isExternalConsumer && ((_a = this.productRelationCustomConfig) === null || _a === void 0 ? void 0 : _a.showBothProductCtasButton)) {
        return {
          buttons: {
            [productCtasButtonType.CART]: Object.assign(Object.assign({}, commonProps), { list: this.inCart ? [(_c = (_b = this.product) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.skuId] : [], icons: {
                addIcon: "shopping-cart",
                removeIcon: "shopping-cart",
              }, labels: {
                addLabel: ((_d = this.secondaryCTALabels) === null || _d === void 0 ? void 0 : _d.addToCartLabel) || ((_e = this.product) === null || _e === void 0 ? void 0 : _e.addToCartLabel),
                removeLabel: ((_f = this.secondaryCTALabels) === null || _f === void 0 ? void 0 : _f.addToCartLabel) || ((_g = this.product) === null || _g === void 0 ? void 0 : _g.addToCartLabel),
              } }),
            [productCtasButtonType.FAVORITES]: Object.assign(Object.assign({}, commonProps), { list: this.inCart ? [(_j = (_h = this.product) === null || _h === void 0 ? void 0 : _h.product) === null || _j === void 0 ? void 0 : _j.skuId] : [], icons: {
                addIcon: "star",
                removeIcon: "star-on",
              }, labels: {
                addLabel: ((_k = this.productRelationCustomConfig.productCtasButtonConfig) === null || _k === void 0 ? void 0 : _k.addToFavoritesLabel)
                  || ((_l = this.secondaryCTALabels) === null || _l === void 0 ? void 0 : _l.addToFavoritesLabel)
                  || ((_m = this.product) === null || _m === void 0 ? void 0 : _m.addToCartLabel),
                removeLabel: ((_o = this.productRelationCustomConfig.productCtasButtonConfig) === null || _o === void 0 ? void 0 : _o.removeFromFavoritesLabel)
                  || ((_p = this.secondaryCTALabels) === null || _p === void 0 ? void 0 : _p.removeFromFavoritesLabel)
                  || ((_q = this.product) === null || _q === void 0 ? void 0 : _q.removeFromCartLabel),
              } }),
          },
        };
      }
      if (this.cartTransferEnabled) {
        return {
          buttons: {
            [productCtasButtonType.CART]: Object.assign(Object.assign({}, commonProps), { list: this.inCart ? [(_s = (_r = this.product) === null || _r === void 0 ? void 0 : _r.product) === null || _s === void 0 ? void 0 : _s.skuId] : [], icons: {
                addIcon: "shopping-cart",
                removeIcon: "shopping-cart",
              }, labels: {
                addLabel: ((_t = this.secondaryCTALabels) === null || _t === void 0 ? void 0 : _t.addToCartLabel) || ((_u = this.product) === null || _u === void 0 ? void 0 : _u.addToCartLabel),
                removeLabel: ((_v = this.secondaryCTALabels) === null || _v === void 0 ? void 0 : _v.addToCartLabel) || ((_w = this.product) === null || _w === void 0 ? void 0 : _w.addToCartLabel),
              } }),
          },
        };
      }
      return {
        buttons: {
          [productCtasButtonType.FAVORITES]: Object.assign(Object.assign({}, commonProps), { list: this.inCart ? [(_y = (_x = this.product) === null || _x === void 0 ? void 0 : _x.product) === null || _y === void 0 ? void 0 : _y.skuId] : [], icons: {
              addIcon: "star",
              removeIcon: "star-on",
            }, labels: {
              addLabel: ((_z = this.secondaryCTALabels) === null || _z === void 0 ? void 0 : _z.addToFavoritesLabel) || ((_0 = this.product) === null || _0 === void 0 ? void 0 : _0.addToCartLabel),
              removeLabel: ((_1 = this.secondaryCTALabels) === null || _1 === void 0 ? void 0 : _1.removeFromFavoritesLabel)
                || ((_2 = this.product) === null || _2 === void 0 ? void 0 : _2.removeFromCartLabel),
            } }),
        },
      };
    };
    this.handleUcEvent = (cta) => {
      CheckoutEventEmitter.dispatchCheckoutEvent(cta, this.checkoutEasyPayload);
    };
    this.renderCTAButtons = () => {
      if (!this.isUnifiedCheckoutEnabled) {
        return this.ctaToComponents(getCustomProductCTAs() || this.buildCTAButtonByResponse());
      }
      if (!Array.isArray(this.product.ctas)) {
        console.error(`[PES]: Could not render ctas. Expected array instead of ${typeof this.product.ctas}`);
        return null;
      }
      return this.product.ctas.map((cta) => {
        var _a, _b, _c;
        return (h("pes-cta-button", { key: cta, icon: "shopping-cart", text: (_c = (_b = (_a = this.ctaInfo) === null || _a === void 0 ? void 0 : _a[cta]) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : null, importance: this.ctaInfoMapping[cta].importance, size: this.ctaInfoMapping[cta].size, onClick: () => this.handleUcEvent(cta) }));
      });
    };
    this.shouldShowPrice = () => {
      return Boolean(this.product.prpPriceLabel && this.product.price && this.product.currency);
    };
    this.getApcPrices = (productId) => {
      var _a, _b;
      if (!productId) {
        return null;
      }
      if (!((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[productId])) {
        return null;
      }
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = this.productAvailabilityInfo.prices[productId];
      return {
        priceLabel,
        previousPriceValue,
        VATInclused,
        previousPrice,
        activePrice,
        activePriceNoTax,
        activePriceValue,
      };
    };
    this.getActivePrice = (productId) => {
      return this.renderApcPrices(productId);
    };
    this.linkClickHandler = (event) => {
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
        if (this.onProductClick) {
          this.onProductClick(this.productId);
        }
        return;
      }
      this.onProductCardClicked();
    };
    this.getButtonType = (productId) => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.productAvailabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[productId !== null && productId !== void 0 ? productId : '']) || null;
      switch (availabilityType) {
        case EAvailabilityType.ADD_TO_CART:
        case EAvailabilityType.PURCHASE_CD:
          return EApcButtonType.ADD_TO_CART;
        default:
          return null;
      }
    };
    this.handleClick = (event, productId) => {
      var _a, _b, _c, _d;
      addToCart(event, productId, this.getLocaleCodes(), (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.apcHost, (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.failedResponse, this.agentChatCscId);
    };
    this.product = undefined;
    this.secondaryCTALabels = undefined;
    this.agentChatCscId = undefined;
    this.cartTransferEnabled = undefined;
    this.myProducts = [];
    this.groupId = undefined;
    this.productId = undefined;
    this.onProductClick = undefined;
    this.apcCtaUrl = undefined;
    this.apcCta = undefined;
    this.productAvailabilityInfo = undefined;
    this.isExternalConsumer = undefined;
    this.productRelationCustomConfig = undefined;
    this.ctaInfo = undefined;
    this.isMobile = undefined;
    this.inCart = false;
    this.ctaInfoMapping = {};
    this.checkoutEasyPayload = null;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.setInCart();
    this.mediaQuery = window.matchMedia('(max-width: 979px)');
    this.isMobile = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', (e) => {
      this.isMobile = e.matches;
    });
    this.ctaInfoMapping = getCtaInfoMapping(((_a = this.product) === null || _a === void 0 ? void 0 : _a.ctas) || [], this.ctaInfo, false);
    const getLocaleData = getLocaleFromBody(isBrowser);
    const country = (_b = getLocaleData === null || getLocaleData === void 0 ? void 0 : getLocaleData.countryCode) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    const locale = `${getLocaleData === null || getLocaleData === void 0 ? void 0 : getLocaleData.languageCode}_${country}`;
    this.checkoutEasyPayload = {
      country,
      locale,
      productId: (_d = (_c = this.product) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.skuId,
    };
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.product.url);
      this.route = new PesRoute({ page: pageType, pageId });
      this.product.url = this.route.url;
    }
  }
  onCcGetOptionsSucceeded(event) {
    if (event.detail.isApcSite && event.detail.agentChatCscId) {
      this.agentChatCscId = event.detail.agentChatCscId;
    }
  }
  onMyProductsChange() {
    this.setInCart();
  }
  renderApcPrices(productId) {
    var _a, _b, _c, _d;
    const prices = this.getApcPrices(productId);
    return (prices && (h("pes-cta-price", { class: "cta-area__price", previousPriceVariant: "beside", priceHTML: prices.activePrice, previousPriceHTML: prices.previousPrice, inStockLabel: (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.inStockLabel, vatLabel: (prices === null || prices === void 0 ? void 0 : prices.VATInclused) ? (_d = (_c = this.apcCta) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.vatLabel : '', resellerLabel: prices.priceLabel, variant: "list" })));
  }
  renderPrices(productId) {
    return (h("div", { class: cn('prices', this.isMobile && 'prices--mobile') }, this.getActivePrice(productId)));
  }
  getLocaleCodes() {
    const { languageCode, countryCode } = getLocaleFromBody(isBrowser) || {};
    return countryCode && languageCode
      ? join('/', countryCode.toLowerCase(), languageCode)
      : '';
  }
  renderApcAddToCartButton(productId) {
    var _a, _b;
    const addToCartButtonLabel = ((_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel) || 'Add to Cart';
    return (this.getButtonType(productId) && (h("pes-cta-button", { class: "cta-area__button", importance: EQdsButtonImportance.STANDARD, size: EQdsButtonSize.STANDARD, text: addToCartButtonLabel, icon: "shopping-cart", onDidClick: (event) => this.handleClick(event.detail, productId) })));
  }
  renderPrimaryCTA(productId) {
    return this.renderApcAddToCartButton(productId);
  }
  renderCTAArea(productId) {
    return (h("div", { class: "cta-area" }, h("div", { class: "cta-area__buttons" }, this.renderPrimaryCTA(productId))));
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return (h("div", { class: "related-product-card" }, h("a", { class: "related-product-card__link", href: this.product.url, onClick: this.linkClickHandler }, h("img", { src: (_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.imageLink.url, alt: (_d = (_c = this.product) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.imageLink.title, class: "related-product-card__img", loading: "lazy" }), h("div", { class: "related-product-card__body" }, h("div", { class: "related-product-card__title" }, (_f = (_e = this.product) === null || _e === void 0 ? void 0 : _e.product) === null || _f === void 0 ? void 0 : _f.description), h("div", { class: "related-product-card__description" }, (_h = (_g = this.product) === null || _g === void 0 ? void 0 : _g.product) === null || _h === void 0 ? void 0 : _h.name))), this.isExternalConsumer && ((_j = this.productRelationCustomConfig) === null || _j === void 0 ? void 0 : _j.showQuantityColumn) && (h("div", { class: "related-product-card" }, h("div", { class: "related-product-card__quantity" }, h("div", { class: "related-product-card__body" }, h("div", { class: "related-product-card__title" }, ((_k = this.productRelationCustomConfig.quantityColumnConfig) === null || _k === void 0 ? void 0 : _k.label) || ''), h("div", { class: "related-product-card__description" }, this.product[(_l = this.productRelationCustomConfig.quantityColumnConfig) === null || _l === void 0 ? void 0 : _l.valueKey] || ''))))), h("div", { class: "related-product-card__controls" }, !this.isApc && this.renderCTAButtons(), !this.isApc && this.shouldShowPrice() && (h("div", { class: "related-product-card__price" }, `${this.product.prpPriceLabel}: `, h("span", { class: "related-product-card__price-value" }, `${this.product.price} ${this.product.currency}`))), this.productAvailabilityInfo && this.isApc && (h("div", null, h("div", { class: "price-cta-container" }, this.renderPrices((_o = (_m = this.product) === null || _m === void 0 ? void 0 : _m.product) === null || _o === void 0 ? void 0 : _o.name)), h("div", { class: "cta-area__row cta-area__price-container" }, this.renderCTAArea((_q = (_p = this.product) === null || _p === void 0 ? void 0 : _p.product) === null || _q === void 0 ? void 0 : _q.name)))))));
  }
  static get is() { return "pes-related-product-card"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-card.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-card.css"]
    };
  }
  static get properties() {
    return {
      "product": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "RelatedProduct",
          "resolved": "{ __typename?: \"RelatedProduct\"; addToCartLabel?: string; currency?: string; groupName?: string; price?: string; product?: Product; prpPriceLabel?: string; removeFromCartLabel?: string; url?: string; brand?: string; ctas?: string[]; }",
          "references": {
            "RelatedProduct": {
              "location": "import",
              "path": "../../../../generated/graphql"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "secondaryCTALabels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSecondaryCTALabels",
          "resolved": "{ addToCartLabel?: string; addToFavoritesLabel?: string; removeFromFavoritesLabel?: string; }",
          "references": {
            "TSecondaryCTALabels": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines a set of labels to be used as a fallback in case `productCtas` property doesn't have labels defined"
        }
      },
      "agentChatCscId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "agent-chat-csc-id",
        "reflect": false
      },
      "cartTransferEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines which CTA button should be shown: \"Add to Cart\" or \"Add to My Products/Remove from My Products\".\n Used only if there are no CTA settings given by a consumer."
        },
        "attribute": "cart-transfer-enabled",
        "reflect": false
      },
      "myProducts": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductGroup[] | null",
          "resolved": "TProductGroup[]",
          "references": {
            "TProductGroup": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of products and groups that are in \"My Products\""
        },
        "defaultValue": "[]"
      },
      "groupId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "ID of the group the product belongs to."
        },
        "attribute": "group-id",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "ID of the product."
        },
        "attribute": "product-id",
        "reflect": false
      },
      "onProductClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(productRef: string) => void",
          "resolved": "(productRef: string) => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "apcCtaUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "apc-cta-url",
        "reflect": false
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "productRelationCustomConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRelatedProductCustomConfig",
          "resolved": "{ showBothProductCtasButton?: boolean; productCtasButtonConfig?: { addToFavoritesLabel?: string; removeFromFavoritesLabel?: string; }; showQuantityColumn?: boolean; quantityColumnConfig?: { label?: string; valueKey?: string; }; }",
          "references": {
            "TRelatedProductCustomConfig": {
              "location": "import",
              "path": "../../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.TCtaInfo",
          "resolved": "{ [key: string]: { type: string; label?: string; primary?: boolean; url?: string; gaAttributes?: TGaAttributes; }; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isMobile": {},
      "inCart": {},
      "ctaInfoMapping": {},
      "checkoutEasyPayload": {}
    };
  }
  static get events() {
    return [{
        "method": "ctaClick",
        "name": "ctaClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event that contains info about what CTA button was clicked"
        },
        "complexType": {
          "original": "TCtaClick",
          "resolved": "{ id?: string; type: string; initialEvent: MouseEvent; product: TMyProductsAddParams; inList?: boolean; onFinish?: (result?: TMyProductsAddResponse | TMyProductsRemoveResponse) => any; bannerContext?: \"body\" | \"header\"; }",
          "references": {
            "TCtaClick": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }, {
        "method": "productCardClicked",
        "name": "productCardClicked",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event that contains info about what related product was clicked\nTODO: is it in use or is it obsolete?"
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "myProducts",
        "methodName": "onMyProductsChange"
      }];
  }
  static get listeners() {
    return [{
        "name": "ccGetOptionsSucceeded",
        "method": "onCcGetOptionsSucceeded",
        "target": "document",
        "capture": false,
        "passive": false
      }];
  }
}
